import { languageMap } from ".."

languageMap.agda = {
	comments: {
		line: "--",
	},
}
